import { createApi } from '@shared/api/api-factory'
import { FINGERPRINTING_DOMAIN } from '@fingerprinting/constants/routes'

const CLIENT_FILES_BASE_URL = 'intake/document-files' as const
const fileApi = createApi({
  prefixUrl: CLIENT_FILES_BASE_URL,
  domain: FINGERPRINTING_DOMAIN,
})

const clientFile = {
  get: async (src: string) => {
    const axiosInstance = fileApi.getAxiosInstance()
    const path = src.replace(/^(\/api)?\/intake\/document-files/, '')
    const response = await axiosInstance.get<Blob>(path, {
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    const blob = response.data
    const contentType = (response.headers['content-type'] as string) || 'application/octet-stream'
    return {
      blob,
      contentType,
    }
  },
  delete: (fileId: number) => {
    return fileApi.delete(`/${fileId}`)
  },
  updateStatus: (fileId: number, status: string, rejectReason?: string) => {
    return fileApi.put(`/${fileId}`, {
      status,
      ...(rejectReason ? { rejectReason } : {}),
    })
  },
  bulkDownload: async (fileIds: number[]) => {
    const axiosInstance = fileApi.getAxiosInstance()
    const response = await axiosInstance.post<Blob>(
      '/bulk-download',
      { fileIds },
      {
        responseType: 'blob',
        headers: {
          Accept: 'application/zip',
        },
      }
    )
    const blob = response.data
    const disposition = (response.headers['content-disposition'] as string) || ''
    const filenameMatch = disposition.match(/filename="?([^"]+)"?/)
    const filename = filenameMatch?.[1] ?? 'documents.zip'
    return { blob, filename }
  },
  updateWithESign: async (fileId: number, signedFile: File) => {
    const axiosInstance = fileApi.getAxiosInstance()
    const formData = new FormData()
    formData.append('signedFile', signedFile)

    const response = await axiosInstance.put(`/${fileId}/esign`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  },
  submitSignedFile: (fileId: number) => {
    return fileApi.post(`/${fileId}/submit-signed-file`)
  },
}

export default clientFile
